import Topline from './Topline.vue';

export default Topline;



// WEBPACK FOOTER //
// ./src/components/topline/index.ts